// extracted by mini-css-extract-plugin
export default {"resetButton":"hadtoIA","editor":"jfVznEL","editorHidden":"OsdvUkN"};